 <!-- 2.-Plataforma E-Learning -->
 <div class="case-studis-area pt--120 pt-md--80 pt-sm--60" style="background-color:#522d6f;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="brook-section-title text-center mb--45">
                    <h6 class="heading-13 text-white text-uppercase fw-500">Aprende desde casa</h6>
                    <div class="bkseparator--25"></div>
                    <h2 class="heading heading-h3 text-white font-40">Plataforma E-Learning</h2>
                </div>
            </div>
        </div>
        <div class="row brook-element-carousel slick-arrow-center" data-slick-options='{
            "slidesToShow": 1, 
            "slidesToScroll": 1, 
            "arrows": true, 
            "infinite": true,
            "dots": false,
            "prevArrow": {"buttonClass": "slick-btn slick-prev", "iconClass": "fas fa-angle-left" },
            "nextArrow": {"buttonClass": "slick-btn slick-next", "iconClass": "fas fa-angle-right" }
        }'>
        <div class="col-12">
            <div class="row mt--30">
                <div class="col-xl-5 col-lg-6">
                    <div class="case-slider-content">
                        <div class="post-count text-white">
                            01. 
                        </div>
                        <h6 class="heading headin-h6 text-white wow move-up animate">Nuestro propósito</h6>
                        <h3 class="heading-font text-white line-height-1-5 wow move-up animate">Transmite, practica y enseña.</h3>
                        <p class="text-white">Participa en la transformación de conciencia en la que todo el planeta está implicado.  </p>
                    </div>
                </div>
                <div class="col-xl-7 col-lg-6">
                    <div class="image-wrap">
                        <div class="image">
                            <div class="image">
                                <img src="assets/img/case-study/home-essential-case-study-image-01.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
    </div>
</div>
   <!-- //Aprende desde casa -->
